// TODO: Deprecate this file in favor of react-queries in /requests folder
import { Req, Res } from '@cbo/shared-library';
import { useMemo } from 'react';
import useCallBsl from '../utils/hooks/useCallBsl';
import toQueryParams from '../utils/objectUtils/toQueryParams';

export const proxies = {
  notifications: 'notifications',
  calendar: 'calendar',
  siteManagement: 'site-management',
  admin: 'admin',
  glAccounts: 'gl-accounts',
  reporting: 'reporting',
  sales: 'sales',
  taskScheduling: 'task-scheduling',
};
const Verb = Req.Firebase.HttpVerb;
export interface ScheduledReportSignedUrlPayload {
  isScheduleReportExport: boolean;
  fileNamePrefix: string;
}

export interface ScheduledReportSignedUrlResponse {
  signedUrl: string;
}

export const useAdminRequests = () => {
  const callBsl = useCallBsl();
  return useMemo(
    () => ({
      getNotifications: async (): Promise<Res.Notifications.Notification[]> =>
        callBsl<{ data: Res.Notifications.Notification[] }>({
          proxy: proxies.notifications,
          verb: Verb.GET,
          pathSegments: ['notifications'],
        }).then(({ data }) => data.map((item) => ({ ...item, createdAt: new Date(item.createdAt) }))),

      markNotificationAsRead: async (notificationId: string): Promise<Res.Notifications.Notification> =>
        callBsl({
          proxy: proxies.notifications,
          verb: Verb.PUT,
          pathSegments: ['notifications', notificationId, 'mark-as-read'],
        }),

      markNotificationAsUnread: async (notificationId: string): Promise<Res.Notifications.Notification> =>
        callBsl({
          proxy: proxies.notifications,
          verb: Verb.PUT,
          pathSegments: ['notifications', notificationId, 'mark-as-unread'],
        }),

      dismissNotification: async (notificationId: string): Promise<Res.Notifications.Notification> =>
        callBsl({
          proxy: proxies.notifications,
          verb: Verb.PUT,
          pathSegments: ['notifications', notificationId, 'dismiss'],
        }),

      getScheduledReportSignedUrl: async (
        payload: ScheduledReportSignedUrlPayload
      ): Promise<ScheduledReportSignedUrlResponse> =>
        callBsl<ScheduledReportSignedUrlResponse>({
          proxy: proxies.sales,
          verb: Verb.POST,
          pathSegments: ['export-helper', 'signed-url'],
          payload,
        }),

      getEventTypesWithNotificationSettingsIds: async (
        notificationSettingsId: string
      ): Promise<Res.Notifications.EventTypeWithNotificationSettingsId[]> =>
        callBsl<Res.Notifications.EventTypeWithNotificationSettingsId[]>({
          proxy: proxies.notifications,
          verb: Verb.GET,
          pathSegments: ['event-types'],
          queryParams: toQueryParams({ notificationSettingsId }),
        }).catch((err) => {
          // TODO: Error handling
          // eslint-disable-next-line no-console
          console.error(err);
          return [];
        }),
    }),
    [callBsl]
  );
};
